import { all, fork, put, takeEvery } from 'redux-saga/effects';
import { CurrentUserAction } from './actions';
import { UserService } from '@nal/services/User.service';
import { getToken } from '@nal/helpers/utility';

const loadMe = async () => {
    try {
        const userService = new UserService();
        const me = await userService.me().toPromise();
        return me;
    } catch (error) {
        return {};
    }
};

export function* getMe() {
    yield takeEvery(CurrentUserAction.GET_ME, function* () {
        if (getToken()) {
            const me = yield loadMe();
            yield put({
                type: CurrentUserAction.GET_ME_SUCCESS,
                me,
            });
        }
    });
}

export default function* rootSaga() {
    yield all([fork(getMe)]);
}
